// Firebase de Pruebas
// export const firebaseConfig = {
//     apiKey: "AIzaSyCudMyYN7uR0gx-xxtRCId4tOf10vYVSHo",
//     authDomain: "cotizadorarrendamientofinbe.firebaseapp.com",
//     projectId: "cotizadorarrendamientofinbe",
//     storageBucket: "cotizadorarrendamientofinbe.appspot.com",
//     messagingSenderId: "641633080018",
//     appId: "1:641633080018:web:720157b1010679370d930b",
//     measurementId: "G-9ZXQ03TGR5"
// };

// Firebase para produccion
export const firebaseConfig = {
    apiKey: "AIzaSyA7TcP--9K9kxiaHmHLvZvQ44kDu9jpvnI",
    authDomain: "pad-finbe-abc.firebaseapp.com",
    projectId: "pad-finbe-abc",
    storageBucket: "pad-finbe-abc.appspot.com",
    messagingSenderId: "157266613652",
    appId: "1:157266613652:web:479f9a454d7b7a018f2b81",
    measurementId: "G-JY0E9WJ98L"
  };